export default "__VITE_ASSET__6e3fbbbe__"